"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const { defineProperty } = Object;
const addComputations = (computationsFetcher) => {
    return function (BaseClass) {
        return class extends BaseClass {
            constructor(...args) {
                super(...args);
                const computations = computationsFetcher(this);
                for (let computation in computations) {
                    let temp = mobx_1.computed(computations[computation]);
                    defineProperty(this, computation, {
                        get: () => temp.get()
                    });
                }
            }
        };
    };
};
exports.addComputations = addComputations;
//# sourceMappingURL=add-computations.js.map